module.exports = __webpack_public_path__ + "./img/logoutIcon.c9c7fb20cf1cc65ed63b9fc21cc30401.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/logoutIcon.png
// module id = ./assets/images/logoutIcon.png
// module chunks = 0